import { bopApi } from '@/lib/api/client';

const PATH = 'v1/download';

export type FileDownloadType = 'transactions' | 'trades' | 'terms-agreements' | 'futures-client-categorisation';

/**
 * Kicks off an async server-side export. The result does NOT come back on this
 * request — bop-api builds the file and pushes a presigned URL over the
 * WebSocket ({type:'fileDownload'}); pages must mount useFileDownloadListener.
 */
export const requestFileDownload = (type: FileDownloadType, parameters: Record<string, unknown>) => bopApi.post(PATH, { json: { type, parameters } }).text();
